import { useAppSelector } from '@monorepo/shared';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { selectAccountAllHa } from '@monorepo/shared/store/haInstanceSlice';
import { Button, ButtonToolbar, Divider, FlexboxGrid, Table } from 'rsuite';
import { textStyle, columnLeft, subTitleStyle } from './AccountDetail';
import { selectCurrentAccount } from '@monorepo/shared/store/accountSlice';

export const HaDetail = () => {
  const { haId, accountId, groupId } = useParams();
  const navigate = useNavigate();
  const accountRegionHas = useAppSelector(selectAccountAllHa);
  const currentAccount = useAppSelector(selectCurrentAccount);
  const [ha, setHa] = useState<Record<string, any>>({});
  const { Column, HeaderCell, Cell } = Table;
  useEffect(() => {
    const has = accountRegionHas?.[accountId || ''];
    if (has?.length && haId) {
      const haObj = has.find((obj: Record<string, any>) => obj.ha_id == haId);
      if (haObj) {
        setHa(haObj);
      }
    }
  }, [accountRegionHas, haId]);
  const goToHaEdit = (id: string) => {
    navigate(`edit`);
  };
  return (
    <div
      className="ha-detail-container"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <div className="ha-info">
        <div
          className="title"
          style={{
            fontSize: '1.2em',
            letterSpacing: '2px',
            marginBottom: '20px'
          }}
        >
          {'Cluster Info'}
        </div>
        <div className="list">
          <FlexboxGrid>
            {/*icon*/}
            <FlexboxGrid.Item colspan={4} style={columnLeft}>
              <div style={subTitleStyle}>Name</div>
              <div style={textStyle}>{ha?.ha_name}</div>
            </FlexboxGrid.Item>
            {/*ha data*/}
            <FlexboxGrid.Item colspan={4} style={columnLeft}>
              <div style={subTitleStyle}>Region</div>
              <div style={textStyle}>{ha?.region_alias}</div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item colspan={4} style={columnLeft}>
              <div style={subTitleStyle}>Status</div>
              <div style={textStyle}>{ha?.ha_status_text || ''}</div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item colspan={12} style={columnLeft}>
              <div style={subTitleStyle}>Notes</div>
              <div style={textStyle}>{ha?.ha_desc || ''}</div>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </div>
      </div>
      <Divider />
      <div className="ha-instances" style={{ flex: '1' }}>
        <div
          className="title"
          style={{
            fontSize: '1.2em',
            letterSpacing: '2px',
            marginBottom: '20px'
          }}
        >
          {'Cluster Instances'}
        </div>
        <div className="instances-table" style={{ minHeight: '300px' }}>
          <Table
            virtualized
            fillHeight
            data={ha?.instances}
            renderEmpty={() => renderEmpty('No Instance Found')}
            onRowClick={(row) => {
              navigate(`instance/${row?.instance_id}`);
            }}
          >
            <Column flexGrow={2} align="left" fixed>
              <HeaderCell>Instance ID</HeaderCell>
              <Cell dataKey="instance_id" />
            </Column>

            <Column flexGrow={1}>
              <HeaderCell>Serial Number</HeaderCell>
              <Cell dataKey="license_sn" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Region</HeaderCell>
              <Cell>
                {(rowData: Record<string, any>) => {
                  return <span>{rowData?.region?.alias}</span>;
                }}
              </Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Version</HeaderCell>
              <Cell dataKey="firmware" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Data Center</HeaderCell>
              <Cell dataKey="project_name" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Health</HeaderCell>
              <Cell>
                {(rowData: Record<string, any>) => {
                  return (
                    <span>{rowData?.cluster_info?.health_status_text}</span>
                  );
                }}
              </Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Node Role</HeaderCell>
              <Cell>
                {(rowData: Record<string, any>) => {
                  return <span>{rowData?.cluster_info?.node_role}</span>;
                }}
              </Cell>
            </Column>
          </Table>
        </div>
      </div>
      <ButtonToolbar style={{ marginBottom: '60px' }}>
        <Button
          appearance="primary"
          onClick={() => haId && goToHaEdit(haId)}
          disabled={
            ha.ha_status !== 'IDLE' ||
            !!groupId ||
            currentAccount?.user_type !== 'Master'
          }
        >
          Modify
        </Button>
      </ButtonToolbar>
    </div>
  );
};

const renderEmpty: any = (info: any) => (
  <div
    style={{
      height: '100%',
      display: 'grid',
      placeItems: 'center'
    }}
  >
    {info}
  </div>
);
